<script setup lang="ts">

import { FilterDateRange, FiltersBar } from '@shared/ui/filters'
import { AppInput } from '@shared/ui/inputs'

import { useFiltersChangelog } from '../model/filters-changelog.hook'

defineOptions({
  name: 'FiltersChangelog',
})

const {
  refSearch,
  refDateRange,
  isLoading,
  handleSearch,
  handleClear,
} = useFiltersChangelog()
</script>

<template>
  <FiltersBar
    class="box-filters-changelog"
    :loading="isLoading"
    @click:submit="handleSearch"
    @click:clear="handleClear"
  >
    <template #fields>
      <AppInput
        v-model="refSearch"
        label="Search"
        placeholder="Action or context"
      />

      <FilterDateRange
        v-model="refDateRange"
        label="Date"
      />
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersChangelog.scss" />
